/**
 * @desc 样品确认-导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.productConfirm.exportExcel.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productConfirm/exportExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
